import React, { useState } from 'react';
import { Colors } from 'library';
import { Card, Icon, Modal, PillButton, Row, Stack, Text } from 'library/ui';
import { GppGoodRounded, PauseCircleFilledRounded, TouchAppRounded } from '@mui/icons-material';
import WelcomeArt from 'assets/images/welcome-art.png';
import UserAttributesApi from 'shared/UserAttributesApi';
import { useUserContext } from 'UserContext';

const steps = [
    {
        icon: TouchAppRounded,
        title: 'Post Your Jobs',
        body: 'Post temporary or permanent needs and reach qualified workers instantly.',
    },
    {
        icon: PauseCircleFilledRounded,
        title: 'Wait While We Work',
        body: 'Our software carefully matches your requirements with a qualified, compliant teacher in our network.',
    },
    {
        icon: GppGoodRounded,
        title: 'Meet Your Match',
        body: "Once matched, your teacher will begin their assignment. If they're a great fit, you can request them for future openings.",
    },
];

export function WelcomeModal({ open, onClose }: { open: boolean; onClose: () => void }) {
    const [page, setPage] = useState<number>(0);
    const { user, refreshAlreadyLoggedInUser } = useUserContext();

    function closeModal() {
        if (user?.welcome_attribute) {
            UserAttributesApi.remove(user.welcome_attribute.id).then(refreshAlreadyLoggedInUser);
        }
        onClose();
    }

    if (!open) {
        return null;
    }

    return (
        <Modal
            id="welcome-modal"
            title={page === 0 ? 'Welcome to Tandem' : 'How It Works'}
            onClose={closeModal}
            width={600}
        >
            {page === 0 ? (
                <Stack gap="md" align="center">
                    <Text align="center" tone="secondary">
                        Find reliable childcare staffing solutions in a day. We connect qualified teachers with centers
                        needing coverage.
                    </Text>
                    <img src={WelcomeArt} alt="Welcome to Tandem" style={{ width: '90%', maxWidth: 360 }} />
                    <Row justify="end" fullWidth>
                        <PillButton id="welcome-modal-next-button" onClick={() => setPage(1)}>
                            Next
                        </PillButton>
                    </Row>
                </Stack>
            ) : (
                <Stack gap="md">
                    <Stack gap="sm">
                        {steps.map((step) => (
                            <Card key={step.title} padding="sm" tone="muted">
                                <Row gap="sm" align="center">
                                    <Icon
                                        icon={step.icon}
                                        size="md"
                                        bgColor={Colors.secondarySoft}
                                        iconColor={Colors.secondary}
                                    />
                                    <Stack gap="none">
                                        <Text weight="bold">{step.title}</Text>
                                        <Text size="sm" tone="secondary">
                                            {step.body}
                                        </Text>
                                    </Stack>
                                </Row>
                            </Card>
                        ))}
                    </Stack>
                    <Row justify="end" fullWidth>
                        <PillButton id="welcome-modal-get-started-button" onClick={closeModal}>
                            Get Started
                        </PillButton>
                    </Row>
                </Stack>
            )}
        </Modal>
    );
}
